export default __webpack_public_path__ + "static/media/html.f54f350d.svg";